<template>
<div class="bg-login">
  
  <div class="form-signin">
    <form @submit.prevent="login" class="p-4">
      <h1 class="h3 mb-3 fw-normal text-white text-uppercase">
        PERUVEN WEB SYSTEM
      </h1>

      <!--   <img class="logo-app" src="/img/logo/logo.png"> -->
      <div class="form-floating mb-3">
        <input
          v-model="usuario"
          type="text"
          class="form-control b-radius text-center"
          id="floatingInput"
          placeholder="Usuario"
          required
        />
        <label class="text-center" for="floatingInput">Usuario</label>
      </div>

      <div class="form-floating mb-3">
        <input
          v-model="password"
          type="password"
          class="form-control b-radius text-center"
          id="floatingPassword"
          placeholder="Password"
          required
        />
        <label for="floatingPassword">Password</label>
      </div>


        <button
          type="submit"
          :disabled="loading"
          class="w-100 btn btn-lg btn-app"
        >
          <div
            v-if="loading"
            class="d-flex justify-content-center align-items-center"
          >
          <span class="spinner-border me-2 spinner-border-sm" role="status"></span>
          <span>Validando...</span>
          </div>

          <span v-else>Iniciar Sesion</span>
        </button>



    </form>

    <div
      class="alert alert-danger alert-dismissible fade show"
      role="alert"
      v-if="error"
    >
      {{ error_msg }}
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        @click="error = false"
      ></button>
    </div>
  </div>


  </div>
</template>

<script setup>
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
import {useAuthStore} from '../store/auth'
const router = useRouter();
const usuario = ref("");
const password = ref("");
const error = ref(false);
const error_msg = ref("");
const loading = ref(false)



const login = async () => {
  try {
    loading.value = !loading.value

       let json = {
        usuario: usuario.value,
        password: password.value,
        }

      useAuthStore()
      .login(json)
        .then(function(data) {
          if(data.status == 'error'){
            loading.value = !loading.value
            error.value = !error.value
            error_msg.value = data.mensaje
          }else{        
          router.push('/')
          }
      })
      .catch((err) => {
        loading.value = !loading.value
        error.value = !error.value
        error_msg.value = 'No se pudo iniciar sesion, ' + err
      });
  } catch (err) {
        loading.value = !loading.value
        error.value = !error.value
        error_msg.value = 'Error iniciando sesion'
  }
};
</script>

<style scoped src="@/assets/css/login-style.css"></style>